import React, { ReactNode } from 'react'
import { CircularProgress } from '@mui/material'
import { MVPButton } from '../../Buttons/MVPButton'
import { R } from '../../../R/R'
import './LoadingModal.scss'

export interface LoadingModalViewProps
{
	title?: string
	withLogo?: boolean
	text: string | ReactNode
	cancelTitle?: string
	clickCancel?: () => void
}

export const LoadingModalView : React.FC<LoadingModalViewProps> = ({ title = 'Loading', withLogo = true, text, cancelTitle, clickCancel }) =>
{
	return (
		<>
			<span className='modal-title'>{title}</span>
			{withLogo && <img id='logo' src={R.images.logoMvp} alt='logo'/>}
			<span className='modal-subtitle'>{text}</span>
			<CircularProgress id='spinner' sx={{accentColor: 'white', color: 'white'}} size='4rem'/>
			<div className='buttons'>
				{cancelTitle &&  <MVPButton onClick={() => clickCancel?.()}>{cancelTitle}</MVPButton>}
			</div>
		</>
	)
}